import {createRouter, createWebHistory} from 'vue-router'
import auth from "@/middleware/auth";
import middlewarePipeline from "@/middleware/middlewarePipeline";
import {useUserStore} from "@/stores/user";
import {config} from "@/config";
import {useThemeSettingsStore} from "@/stores/themeSettings.js";
import {useMainOrdersStore} from "@/stores/mainOrders.js";
//import {useAllOrdersStore} from "@/stores/accountOrders.js";

const router = createRouter({
  history: createWebHistory(import.meta.env.BASE_URL),
  base: import.meta.BASE_URL,
  scrollBehavior(to, from, savedPosition) {
    if (savedPosition) {
      return savedPosition;
    } else {
      return {top: 0};
    }
  },
  routes: [
    {
      path: '/login',
      name: 'Login',
      component: () => import('@/views/auth/login/index.vue')
    },
    {
      path: "/forgot-password",
      name: "forgot-password",
      component: () => import("@/views/auth/forgot-password.vue"),
    },
    {
      path: "/register",
      name: "reg",
      component: () => import("@/views/auth/register/index.vue"),
    },
    {
      path: "/:catchAll(.*)",
      name: "404",
      component: () => import("@/views/404.vue"),
    },
    {
      path: '/otp',
      name: 'discord-otp',
      component: () => import('@/views/otp.vue'),
    },
    {
      path: "/",
      name: "Dashboard",
      redirect: "/profile",
      component: () => import("@/Layout/index.vue"),
      meta: {
        middleware: [auth],
      },
      children: [
        {
          path: "blank-page",
          name: "blank-page",
          component: () => import("@/views/blank-page.vue"),
        },
        {
          path: "home",
          name: "home",
          component: () => import("@/views/home/index.vue"),
          meta: {
            hide: true,
          },
        },
        {
          path: "profile",
          name: "profile",
          component: () => import("@/views/profile/index.vue"),
          meta: {
            groupParent: "account",
          },
        },
        {
          path: 'inbox',
          name: 'Inbox',
          component: () => import('@/views/inbox/index.vue'),
          meta: {
            groupParent: "account",
            hide: true,
            fullWithHeader: true,
            title: "My Inbox"
          }
        },
        {
          path: 'counter',
          name: 'counter',
          component: () => import('@/views/Counter.vue')
        },
        {
          path: 'hot-orders',
          name: 'hot-orders',
          component: () => import('@/views/hotOrders/index.vue'),
          meta: {
            groupParent: "orders",
          },
          children: [
            {
              path: 'boost',
              name: 'boost-hot-orders',
              component: () => import('@/views/hotOrders/admin/boost.vue'),
              meta: {
                hide: true,
                fullWithHeader: true,
                title: 'Boost Hot Orders'
              }
            },
            {
              path: 'account',
              name: 'account-hot-orders',
              component: () => import('@/views/hotOrders/account.vue'),
              /*beforeEnter: (to, from, next) => {
                  if (useUserStore().getAccountGamePreferences.length) {
                      next()
                  } else {
                      next({name: 'games-account'})
                  }
              }*/
            },
            {
              path: 'currency-buy',
              name: 'currency-buy-hot-orders',
              component: () => import('@/views/hotOrders/currencyBuy.vue'),
              /*beforeEnter: (to, from, next) => {
                  if (useUserStore().getCurrencyBuyGamePreferences.length) {
                      next()
                  } else {
                      next({name: 'games-currency-buy'})
                  }
              }*/
            },
            {
              path: 'currency-sell',
              name: 'currency-sell-hot-orders',
              component: () => import('@/views/hotOrders/currencySell.vue'),
              /*beforeEnter: (to, from, next) => {
                  if (useUserStore().getCurrencySellGamePreferences.length) {
                      next()
                  } else {
                      next({name: 'games-currency-sell'})
                  }
              }*/
            },
          ]
        },
        {
          path: 'manage-applicants',
          name: 'manage-applicants',
          component: () => import('@/views/manageApplicants/index.vue'),
          meta: {
            groupParent: "orders applicants",
          },
          children: [
            {
              path: 'boost',
              children: [
                {
                  path: '',
                  name: 'boost-orders-applicants',
                  component: () => import('@/views/manageApplicants/boost/orders.vue'),
                },
                {
                  path: ':orderID',
                  name: 'manage-applicants-boost-order',
                  component: () => import('@/views/manageApplicants/boost/applicants.vue'),
                  meta: {
                    hide: true,
                  }
                }
              ]
            },
            {
              path: 'account',
              children: [
                {
                  path: '',
                  name: 'manage-applicants-account-orders',
                  component: () => import('@/views/manageApplicants/account/orders.vue'),
                },
                {
                  path: ':orderID',
                  name: 'manage-applicants-account-order',
                  component: () => import('@/views/manageApplicants/account/applicants.vue'),
                  meta: {
                    hide: true,
                  }
                }
              ]
            },
            {
              path: 'currency-buy',
              children: [
                {
                  path: '',
                  name: 'manage-applicants-currency-buy-orders',
                  component: () => import('@/views/manageApplicants/currencyBuy/orders.vue'),
                },
                {
                  path: ':orderID',
                  name: 'manage-applicants-currency-buy-order',
                  component: () => import('@/views/manageApplicants/currencyBuy/applicants.vue'),
                  meta: {
                    hide: true,
                  }
                }
              ]
            },
            {
              path: 'currency-sell',
              children: [
                {
                  path: '',
                  name: 'currency-sell-orders-applicants',
                  component: () => import('@/views/manageApplicants/currencySell/orders.vue'),
                },
                {
                  path: ':orderID',
                  name: 'manage-applicants-currency-sell-order',
                  component: () => import('@/views/manageApplicants/currencySell/applicants.vue'),
                  meta: {
                    hide: true,
                  }
                }
              ]
            },
          ]
        },
        {
          path: 'games',
          name: 'games',
          component: () => import('@/views/games/index.vue'),
          meta: {
            groupParent: "games",
          },
          children: [
            {
              path: 'boost',
              name: 'games-boost',
              component: () => import('@/views/games/boost.vue'),
            },
            {
              path: 'currency-buy',
              name: 'games-currency-buy',
              component: () => import('@/views/games/currencyBuy.vue'),
            },
            {
              path: 'currency-sell',
              name: 'games-currency-sell',
              component: () => import('@/views/games/currencySell.vue'),
            },
            {
              path: 'account',
              name: 'games-account',
              component: () => import('@/views/games/account.vue'),
            }
          ]
        },
        /*{
          path: 'my-orders',
          meta: {
            groupParent: "orders",
          },
          children: [
            {
              path: '',
              name: 'my-orders',
              component: () => import('@/views/hotOrders/myOrders/index.vue'),
            },
            {
              path: 'update/account/:id/:orderTitle',
              name: 'update-account-order',
              component: () => import('@/views/hotOrders/myOrders/account/update.vue')
            },
            {
              path: 'update/boost/:id',
              name: 'update-boost-order',
              component: () => import('@/views/hotOrders/myOrders/boost/update2.vue')
            },
            {
              path: 'update/currencyBuy/:id/:orderTitle',
              name: 'update-currencyBuy-order',
              component: () => import('@/views/hotOrders/myOrders/currencyBuy/update.vue')
            },
            {
              path: 'update/currencySell/:id',
              name: 'update-currencySell-order',
              component: () => import('@/views/hotOrders/myOrders/currencySell/update.vue')
            }
          ]
        },*/
        {
          path: 'devices',
          name: 'connected-devices',
          component: () => import('@/views/profile/sessions.vue'),
          meta: {
            groupParent: "account",
          },
        },
        {
          path: 'identity-verification',
          name: 'identity-verification',
          component: () => import('@/views/profile/identityVerification.vue'),
          meta: {
            groupParent: "account"
          },
        },
        {
          path: 'financial',
          name: 'financial',
          component: () => import('@/views/profile/financial.vue'),
          meta: {
            groupParent: "account"
          },
        },
        /*{
          path: 'verify-kyc',
          name: 'verify-kyc',
          component: () => import('@/views/kyc/index.vue'),
          meta: {
            groupParent: "kyc management",
            animation: ''
          },
        },*/
        {
          path: 'verify-user',
          name: 'verify-user',
          component: () => import('@/views/kyc/accountDetails/index.vue'),
          meta: {
            hide: true,
            animation: ''
          },
        },
        {
          path: 'wallet',
          name: 'Wallet',
          component: () => import('@/views/wallet/index.vue'),
          meta: {
            hide: true,
            fullWithHeader: true
          }
        },
        {
          path: 'watchdog',
          meta: {
            groupParent: "watchdog",
          },
          children: [
            {
              path: 'boost',
              name: 'watchdog-boost',
              component: () => import('@/views/watchdog/boost/index.vue'),
              meta: {
                hide: true,
                fullWithHeader: true,
                title: "Watchdog"
              },
            },
            {
              path: 'market-map',
              name: 'market-map',
              component: () => import('@/views/watchdog/marketMap/index.vue'),
              meta: {
                hide: true,
                fullWithHeader: true,
                title: "Market Map"
              },
            },
          ]
        },
        {
          path: 'updatedog',
          name: 'updatedog',
          component: () => import('@/views/updateDog/index.vue'),
          meta: {
            hide: true,
            fullWithHeader: true,
            title: "Boost Updatedog",
            groupParent: "orders",
          },
        },
        {
          path: 'chat',
          name: 'chat',
          component: () => import('@/views/chat/index.vue'),
          meta: {
            hide: true,
            fullScreen: true
          },
        },
        {
          path: 'orders',
          name: 'Orders',
          component: () => import('@/views/orders/index.vue'),
          meta: {
            groupParent: "orders",
          },
          children: [
            {
              path: 'boost',
              children: [
                {
                  path: '',
                  name: 'boost-orders',
                  component: () => import('@/views/orders/Boost.vue'),
                  meta: {
                    hide: true,
                    fullWithHeader: true,
                    title: "Boost Orders"
                  },
                  beforeEnter: (to, from, next) => {
                    const ordersStore = useMainOrdersStore();
                    if (from.name !== 'boost-order-details' && from.name !== 'boost-order-add') {
                      ordersStore.reset_selected_orders('Boost');
                      ordersStore.reset_filters();
                      ordersStore.reset_finalized();
                      ordersStore.resetBoostOrdersSearch();
                      ordersStore.resetBoostOrdersSort();
                    }
                    next()
                  },
                },
                {
                  path: ':id',
                  name: 'boost-order-details',
                  component: () => import('@/views/orders/Details/Boost/Edit.vue'),
                  meta: {
                    hide: true,
                    fullWithHeader: true,
                    title: "Boost Order"
                  },
                },
                {
                  path: 'add',
                  name: 'boost-order-add',
                  component: () => import('@/views/orders/Details/Boost/Add.vue'),
                  meta: {
                    hide: true,
                    fullWithHeader: true,
                    title: "Add Boost Order"
                  },
                }
              ]
            },
            {
              path: 'currency-buy',
              children: [
                {
                  path: '',
                  name: 'currency-buy-orders',
                  component: () => import('@/views/orders/CurrencyBuy.vue'),
                  meta: {
                    hide: true,
                    fullWithHeader: true,
                    title: "Currency Buy Orders"
                  },
                  beforeEnter: (to, from, next) => {
                    const ordersStore = useMainOrdersStore();
                    if (from.name !== 'currency-buy-order-details' && from.name !== 'currency-buy-order-add') {
                      ordersStore.reset_selected_orders('CurrencyBuy');
                      ordersStore.reset_filters();
                      ordersStore.reset_finalized();
                      ordersStore.resetCurrencyBuyOrdersSearch();
                      ordersStore.resetCurrencyBuyOrdersSort();
                    }
                    next()
                  },
                },
                {
                  path: ':id',
                  name: 'currency-buy-order-details',
                  component: () => import('@/views/orders/Details/CurrencyBuy/Edit.vue'),
                  meta: {
                    hide: true,
                    fullWithHeader: true,
                    title: "Currency Buy Order"
                  },
                },
                {
                  path: 'add',
                  name: 'currency-buy-order-add',
                  component: () => import('@/views/orders/Details/CurrencyBuy/AddOrder/Add.vue'),
                  meta: {
                    hide: true,
                    fullWithHeader: true,
                    title: "Add Currency Buy Order"
                  },
                }
              ]
            },
            {
              path: 'currency-sell',
              children: [
                {
                  path: '',
                  name: 'currency-sell-orders',
                  component: () => import('@/views/orders/CurrencySell.vue'),
                  meta: {
                    hide: true,
                    fullWithHeader: true,
                    title: "Currency Sell Orders"
                  },
                  beforeEnter: (to, from, next) => {
                    const ordersStore = useMainOrdersStore();
                    if (from.name !== 'currency-sell-order-details' && from.name !== 'currency-sell-order-add') {
                      ordersStore.reset_selected_orders('CurrencySell');
                      ordersStore.reset_filters();
                      ordersStore.reset_finalized();
                      ordersStore.resetCurrencySellOrdersSearch();
                      ordersStore.resetCurrencySellOrdersSort();
                    }
                    next()
                  }
                },
                {
                  path: ':id',
                  name: 'currency-sell-order-details',
                  component: () => import('@/views/orders/Details/CurrencySell/Edit.vue'),
                  meta: {
                    hide: true,
                    fullWithHeader: true,
                    title: "Currency Sell Order"
                  }
                },
                {
                  path: 'add',
                  name: 'currency-sell-order-add',
                  component: () => import('@/views/orders/Details/CurrencySell/AddOrder/Add.vue'),
                  meta: {
                    hide: true,
                    fullWithHeader: true,
                    title: "Add Currency Sell Order"
                  },
                }
              ]
            },
            {
              path: 'account',
              children: [
                {
                  path: '',
                  name: 'account-orders',
                  component: () => import('@/views/orders/Account.vue'),
                  meta: {
                    hide: true,
                    fullWithHeader: true,
                    title: "Account Orders"
                  },
                  beforeEnter: (to, from, next) => {
                    const ordersStore = useMainOrdersStore();
                    if (from.name !== 'account-order-details' && from.name !== 'account-order-add') {
                      ordersStore.reset_selected_orders('Account');
                      ordersStore.reset_filters();
                      ordersStore.reset_finalized();
                      ordersStore.resetAccountOrdersSearch();
                      ordersStore.resetAccountOrdersSort();
                    }
                    next()
                  },
                },
                /*{
                  path: '',
                  name: 'account-orders',
                  component: () => import('@/views/orders/Account2.vue'),
                  meta: {
                    hide: true,
                    fullWithHeader: true,
                    title: "Account Orders"
                  },
                  beforeEnter: (to, from, next) => {
                    const ordersStore = useAllOrdersStore();
                    if (from.name !== 'account-order-details' && from.name !== 'account-order-add') {
                      ordersStore.resetFilters();
                      ordersStore.resetFinalized();
                      ordersStore.resetKeyword();
                      ordersStore.resetSort();
                    }
                    next()
                  },
                },*/
                {
                  path: ':id',
                  name: 'account-order-details',
                  component: () => import('@/views/orders/Details/Account/Edit.vue'),
                  meta: {
                    hide: true,
                    fullWithHeader: true,
                    title: "Account Order"
                  },
                },
                {
                  path: 'add',
                  name: 'account-order-add',
                  component: () => import('@/views/orders/Details/Account/Add.vue'),
                  meta: {
                    hide: true,
                    fullWithHeader: true,
                    title: "Add Account Order"
                  },
                }
              ]
            },
            {
              path: 'gift-card',
              children: [
                {
                  path: '',
                  name: 'gift-card-orders',
                  component: () => import('@/views/orders/GiftCard.vue'),
                  meta: {
                    hide: true,
                    fullWithHeader: true,
                    title: "Gift Card Orders"
                  },
                  beforeEnter: (to, from, next) => {
                    const ordersStore = useMainOrdersStore();
                    if (from.name !== 'gift-card-order-details' && from.name !== 'gift-card-order-add') {
                      ordersStore.reset_selected_orders('GiftCard');
                      ordersStore.reset_filters();
                      ordersStore.reset_finalized();
                      ordersStore.resetGiftCardOrdersSearch();
                      ordersStore.resetGiftCardOrdersSort();
                    }
                    next()
                  },
                },
                {
                  path: ':id',
                  name: 'gift-card-order-details',
                  component: () => import('@/views/orders/Details/GiftCard/Edit.vue'),
                  meta: {
                    hide: true,
                    fullWithHeader: true,
                    title: "Gift Card Order"
                  },
                },
                {
                  path: 'add',
                  name: 'gift-card-order-add',
                  component: () => import('@/views/orders/Details/GiftCard/Add.vue'),
                  meta: {
                    hide: true,
                    fullWithHeader: true,
                    title: "Add Gift Card Order"
                  },
                }
              ]
            },
            {
              path: 'item',
              children: [
                {
                  path: '',
                  name: 'item-orders',
                  component: () => import('@/views/orders/Item.vue'),
                  meta: {
                    hide: true,
                    fullWithHeader: true,
                    title: "Item Orders"
                  },
                  beforeEnter: (to, from, next) => {
                    const ordersStore = useMainOrdersStore();
                    if (from.name !== 'item-order-details' && from.name !== 'item-order-add') {
                      ordersStore.reset_selected_orders('Item');
                      ordersStore.reset_filters();
                      ordersStore.reset_finalized();
                      ordersStore.resetItemOrdersSearch();
                      ordersStore.resetItemOrdersSort();
                    }
                    next()
                  },
                },
                {
                  path: ':id',
                  name: 'item-order-details',
                  component: () => import('@/views/orders/Details/Item/Edit.vue'),
                  meta: {
                    hide: true,
                    fullWithHeader: true,
                    title: "Item Order"
                  },
                },
                {
                  path: 'add',
                  name: 'item-order-add',
                  component: () => import('@/views/orders/Details/Item/Add.vue'),
                  meta: {
                    hide: true,
                    fullWithHeader: true,
                    title: "Add Item Order"
                  },
                }
              ]
            },
            {
              path: 'shop',
              children: [
                {
                  path: '',
                  name: 'shop-orders',
                  component: () => import('@/views/orders/Shop.vue'),
                  meta: {
                    hide: true,
                    fullWithHeader: true,
                    title: "Shop Orders"
                  },
                  beforeEnter: (to, from, next) => {
                    const ordersStore = useMainOrdersStore();
                    if (from.name !== 'shop-order-details' && from.name !== 'shop-order-add') {
                      ordersStore.reset_selected_orders('Shop');
                      ordersStore.reset_filters();
                      ordersStore.reset_finalized();
                      ordersStore.resetShopOrdersSearch();
                      ordersStore.resetShopOrdersSort();
                    }
                    next()
                  },
                },
                {
                  path: ':id',
                  name: 'shop-order-details',
                  component: () => import('@/views/orders/Details/Shop/Edit2.vue'),
                  meta: {
                    hide: true,
                    fullWithHeader: true,
                    title: "Shop Order"
                  },
                },
                {
                  path: 'add',
                  name: 'shop-order-add',
                  component: () => import('@/views/orders/Details/Shop/Add2.vue'),
                  meta: {
                    hide: true,
                    fullWithHeader: true,
                    title: "Add Shop Order"
                  },
                }
              ]
            },
          ]
        },
        {
          path: 'stocks',
          name: 'Stocks',
          component: () => import('@/views/stocks/index.vue'),
          meta: {
            groupParent: "stocks",
          },
          children: [
            {
              path: 'overview',
              name: 'stocks-overview',
              component: () => import('@/views/stocks/overview.vue'),
              meta: {
                hide: true,
              }
            },
            {
              path: 'transfer/:orderType/:id',
              name: 'new-transfer',
              component: () => import('@/views/stocks/newTransfer.vue'),
              meta: {
                hide: true,
                fullWithHeader: true
              },
            },
            {
              path: ':game',
              children: [
                {
                  path: '',
                  name: 'stocks-servers',
                  component: () => import('@/views/stocks/servers.vue'),
                  meta: {
                    hide: true,
                  },
                },
                {
                  path: ':server',
                  name: 'stocks-new-transfer',
                  component: () => import('@/views/stocks/add.vue'),
                  meta: {
                    hide: true,
                    fullWithHeader: true
                  },
                },
              ]
            },
            {
              path: 'orders',
              children: [
                {
                  path: '',
                  name: 'stocks-orders',
                  component: () => import('@/views/stocks/orders/index.vue'),
                  meta: {
                    hide: true,
                    fullWithHeader: true,
                    title: "Stock Orders"
                  },
                  beforeEnter: (to, from, next) => {
                    const ordersStore = useMainOrdersStore();
                    if (from.name !== 'stocks-order-details' && from.name !== 'stocks-orders-add') {
                      ordersStore.reset_filters();
                      ordersStore.reset_finalized();
                      ordersStore.resetCurrencyTransferOrdersSearch();
                      ordersStore.resetCurrencyTransferOrdersSort();
                    }
                    next()
                  }
                },
                {
                  path: ':id',
                  name: 'stocks-order-details',
                  component: () => import('@/views/stocks/update.vue'),
                  meta: {
                    hide: true,
                    fullWithHeader: true,
                    title: "Stock Order"
                  }
                },
                {
                  path: 'add',
                  name: 'stocks-orders-add',
                  component: () => import('@/views/stocks/add.vue'),
                  meta: {
                    hide: true,
                    fullWithHeader: true,
                    title: "Add Stock Order"
                  },
                },
              ]
            },
            {
              path: 'game-accounts',
              children: [
                {
                  path: '',
                  name: 'game-accounts-list',
                  component: () => import('@/views/stocks/gameAccounts.vue'),
                  meta: {
                    hide: true,
                    title: 'Game Accounts'
                  }
                }
              ]
            },
            {
              path: 'supplier',
              children: [
                {
                  path: '',
                  name: 'stocks-supplier',
                  component: () => import('@/views/stocks/supplier/index.vue'),
                  meta: {
                    hide: true,
                    fullWithHeader: true,
                    title: "Supplier Stock"
                  },
                },
              ]
            },
            {
              path: 'currency-buy-ads',
              children: [
                {
                  path: '',
                  name: 'currency-buy-ads',
                  component: () => import('@/views/stocks/currencyBuyAds/index.vue'),
                  meta: {
                    hide: true,
                    fullWithHeader: true,
                    title: "Currency Buy Ads"
                  },
                },
              ]
            },
            {
              path: 'supplier/:game',
              children: [
                {
                  path: '',
                  name: 'stocks-supplier-game',
                  component: () => import('@/views/stocks/supplier/stocks.vue'),
                  meta: {
                    hide: true,
                    fullWithHeader: true,
                    title: "Supplier Stock"
                  }
                }
              ]
            },
            {
              path: 'supplier/settings',
              children: [
                {
                  path: '',
                  name: 'stocks-supplier-settings',
                  component: () => import('@/views/stocks/supplier/settings/index.vue'),
                  meta: {
                    hide: true,
                    fullWithHeader: true,
                    title: "Supplier Settings"
                  }
                }
              ]
            },
            {
              path: 'calculator',
              name: 'calculator',
              component: () => import('@/views/stocks/g2gCalculator.vue'),
              meta: {
                hide: true,
                fullWithHeader: true
              },
            }
          ]
        },
        {
          path: 'management',
          name: 'Management',
          component: () => import('@/views/management/Index.vue'),
          meta: {
            groupParent: "management",
          },
          children: [
            {
              path: 'stores',
              name: 'management-stores',
              component: () => import('@/views/management/Stores.vue'),
              meta: {
                hide: true,
                fullWithHeader: true,
                title: "Manage Stores"
              }
            },
            {
              path: 'currency-pricing',
              name: 'in-game-currency-pricing',
              component: () => import('@/views/stocks/currencyPricing/index.vue'),
              meta: {
                hide: true,
                fullWithHeader: true,
                title: "Currency Pricing"
              },
            },
            {
              path: 'verify-kyc',
              name: 'verify-kyc',
              component: () => import('@/views/verifyKYC/index.vue'),
              meta: {
                hide: true,
                fullWithHeader: true,
                title: "Verify KYC Documents"
              },
            },
            {
              path: 'customer-session',
              name: 'customer-session',
              component: () => import('@/views/management/customerReviews/Index.vue'),
              meta: {
                hide: true,
                fullWithHeader: true,
                title: "Customer Session"
              },
            },
          ]
        },
        {
          path: 'payment',
          meta: {
            groupParent: "payment",
          },
          children: [
            {
              path: 'boost',
              name: 'payment-boost',
              component: () => import('@/views/payment/boost.vue'),
              meta: {
                hide: true,
                fullWithHeader: true,
                title: "Boost Payment"
              }
            }
          ]
        },
        {
          path: 'users',
          name: 'Users',
          component: () => import('@/views/users/index.vue'),
          meta: {
            groupParent: "users",
            fullWithHeader: true,
            hide: true,
          }
        },
        {
          path: 'upload-project',
          name: 'upload-project',
          component: () => import('@/views/UploadProject.vue'),
          meta: {
            groupParent: "upload project",
            fullWithHeader: true,
            hide: true,
          }
        },
        {
          path: 'chatgpt',
          name: 'ChatGpt',
          component: () => import('@/views/gpt/chatgpt.vue'),
          meta: {
            hide: true,
            fullWithHeader: true,
            //groupParent: "users",
            //fullWithHeader: true,
            //title: "Chat GPT"
          },
        },
        {
          path: 'gpt-details',
          name: 'gpt-details',
          component: () => import('@/views/gpt/gptDetails.vue'),
          meta: {
            hide: true,
            fullWithHeader: true,
          },
        },
        {
          path: 'add-chatgpt',
          name: 'add-chatgpt',
          component: () => import('@/views/gpt/addChatGpt.vue'),
          meta: {
            hide: true,
            fullWithHeader: true,
            //groupParent: "users",
            //fullWithHeader: true,
            //title: "Chat GPT"
          },
        },
        {
          path: 'notifications',
          name: 'notifications',
          component: () => import('@/views/blank-page.vue'),
        },
        {
          path: '/forbidden',
          name: 'forbidden',
          component: () => import('@/views/Forbidden.vue'),
          meta: {
            hide: true,
          },
        },
        {
          path: '/test',
          name: 'Test',
          component: () => import('@/views/Test.vue'),
          meta: {
            hide: true,
            fullScreen: true
          },
        },
      ]
    }
  ]
})
router.beforeEach((to, from, next) => {
  const themeSettingsStore = useThemeSettingsStore()
  if (to.name === 'verify-user' || to.name === 'verify-kyc') {
    to.meta.animation = themeSettingsStore.getLanguage === 'fa' ? 'singleUser-fa' : 'singleUser';
  }
  if (to.meta?.title) {
    document.title = to.meta?.title + " - " + config.siteName
  } else {
    const titleText = to.name;
    const words = titleText.split(" ");
    const wordsLength = words.length;
    if (titleText) {
      for (let i = 0; i < wordsLength; i++) {
        words[i] = words[i][0].toUpperCase() + words[i].substr(1);
      }
    }
    document.title = words + " - " + config.siteName
  }

  /** Navigate to next if middleware is not applied */
  if (!to.meta.middleware) {
    return next()
  }

  if (to.name === 'chat' || to.name === 'ChatGpt') {
    themeSettingsStore.navbarType = 'hidden'
    themeSettingsStore.footerType = 'hidden'
    themeSettingsStore.language = 'en'
    themeSettingsStore.direction = false
    //themeSettingsStore.sidebarCollasp = true
  } else {
    themeSettingsStore.navbarType = 'sticky'
    themeSettingsStore.footerType = 'static'
    //themeSettingsStore.sidebarCollasp = false
  }

  const middleware = to.meta.middleware;
  const gate = to.meta.gate;
  const context = {to, from, next, gate}
  return middleware[0]({
    ...context,
    next: middlewarePipeline(context, middleware, 1)
  })
});
router.afterEach(() => {
  // Remove initial loading
  const appLoading = document.getElementById("loading-bg");
  if (appLoading) {
    appLoading.style.display = "none";
  }
});
export default router
